import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { createReimbursementReport } from "~/providers/api/reimbursementReport";

export const useCreateReimbursementReport = (consultationId?: string) => {
  const queryClient = useQueryClient();

  const { mutate: createReimbursementReportMutation, isPending } = useMutation({
    mutationFn: (zoomMeetingId: string) =>
      createReimbursementReport(zoomMeetingId, consultationId),
    onError: () =>
      toast.error(
        "We had trouble starting the progress note. If the issue persists, please reload the page.",
      ),
    onSuccess: async () => {
      toast.success("Progress note generation started.");
      await queryClient.invalidateQueries({
        queryKey: ["getReimbursementReport", consultationId],
      });
    },
  });

  return { createReimbursementReportMutation, isPending };
};
